/* eslint-disable */
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Box, TextField, Button } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { themeColors } from '../../ConstantColors'; // using your existing themeColors from constants

export const RejectionDialog = ({ open, onClose, onReject, requestNumber }) => {
    const [rejectionReason, setRejectionReason] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        if (!rejectionReason.trim()) {
            setError('Rejection reason is required');
            return;
        }
        if (rejectionReason.trim().length < 10) {
            setError('Reason must be at least 10 characters');
            return;
        }

        onReject(rejectionReason.trim()); // Pass the trimmed text reason
        setRejectionReason('');
        setError('');
        onClose();
    };

    const handleClose = () => {
        setRejectionReason('');
        setError('');
        onClose();
    };


    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '16px'
                }
            }}
        >
            <DialogTitle
                sx={{
                    bgcolor: themeColors.error,
                    color: themeColors.white,
                    py: 3,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Box>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Reject Travel Request
                    </Typography>
                    <Typography variant="subtitle2" sx={{ mt: 1, opacity: 0.9 }}>
                        Request: {requestNumber}
                    </Typography>
                </Box>
                <IconButton onClick={handleClose} sx={{ color: themeColors.white }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 3 }}>
                <Typography variant="subtitle1" sx={{ mb: 2, color: themeColors.text }}>
                    Please provide a detailed reason for rejecting this travel request.
                </Typography>
                <TextField
                    value={rejectionReason}
                    onChange={(e) => {
                        setRejectionReason(e.target.value);
                        if (e.target.value.trim()) {
                            setError('');
                        }
                    }}
                    label="Reason for Rejection"
                    multiline
                    rows={4}
                    fullWidth
                    variant="outlined"
                    error={!!error}
                    helperText={error}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '&.Mui-focused fieldset': {
                                borderColor: themeColors.error
                            }
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: themeColors.error
                        }
                    }}
                />
            </DialogContent>

            <DialogActions
                sx={{
                    p: 3,
                    gap: 2,
                    bgcolor: themeColors.light,
                    borderTop: `1px solid ${themeColors.error}`
                }}
            >
                <Button
                    onClick={handleClose}
                    variant="outlined"
                    sx={{
                        borderColor: themeColors.error,
                        color: themeColors.error,
                        minWidth: 150,
                        textTransform: 'none',
                        '&:hover': {
                            borderColor: themeColors.error,
                            backgroundColor: `${themeColors.error}10`
                        }
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                        bgcolor: 'red',
                        color: themeColors.white,
                        minWidth: 150,
                        textTransform: 'none',
                        '&:hover': {
                            bgcolor: themeColors.error,
                            opacity: 0.9
                        }
                    }}
                >
                    Reject Request
                </Button>
            </DialogActions>
        </Dialog>
    );
};
